import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Select, Radio, Spin } from 'antd';
import { changeRefBikeLeadRequest } from '../../../redux/actions/change_ref_bike_lead.actions';
import FlagIcon from '@material-ui/icons/Flag';

const { Option } = Select;

const formFieldStyle = {
    mainContainer: { marginBottom: 24 },
    fieldStyle: { width: 428 },
    container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
    wrapper: { width: '100%' },
    warningIcon: { display: 'inline-block', verticalAlign: 'middle', marginLeft: 8 }
};

class BikeRagQuestions extends Component {
    constructor(props) {
        super(props);
    }

    handleChange = (value, key) => {
        const { dispatch, lead_id, bike_details: { _id} } = this.props;

        dispatch(changeRefBikeLeadRequest(_id, key, value, lead_id));
    };

    render() {
        const {
            written_off, condition,
            document_history, non_runner
        } = this.props.bike_details;

        return (
            <Spin tip="Saving answer..." spinning={this.props.loading}>
                <div style={{ maxWidth: 470, marginBottom: 20 }}>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>Service history?</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Radio.Group
                                    defaultValue={document_history}
                                    buttonStyle="solid"
                                    onChange={e => this.handleChange(e.target.value, 'document_history')}
                                >
                                    <Radio.Button value="Full History">Full</Radio.Button>
                                    <Radio.Button value="Part History">Part</Radio.Button>
                                    <Radio.Button value="No History">None</Radio.Button>
                                    <Radio.Button value="First not due">First not due</Radio.Button>
                                </Radio.Group>
                                {document_history !== 'Full History' &&
                                    <FlagIcon color="error" style={formFieldStyle.warningIcon}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>Is the motorbike a non-runner?</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Radio.Group
                                    defaultValue={non_runner}
                                    buttonStyle="solid"
                                    onChange={e => this.handleChange(e.target.value, 'non_runner')}
                                >
                                    <Radio.Button value="No">No</Radio.Button>
                                    <Radio.Button value="Yes">Yes</Radio.Button>
                                    <Radio.Button value="Just needs a battery">Needs a battery</Radio.Button>
                                </Radio.Group>
                                {non_runner !== 'No' &&
                                    <FlagIcon color="error" style={formFieldStyle.warningIcon}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>Has your bike ever been the subject of an insurance write off?</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Radio.Group
                                    defaultValue={written_off}
                                    buttonStyle="solid"
                                    onChange={e => this.handleChange(e.target.value, 'written_off')}
                                >
                                    <Radio.Button value={false}>No</Radio.Button>
                                    <Radio.Button value>Yes</Radio.Button>
                                </Radio.Group>
                                {written_off &&
                                    <FlagIcon color="error" style={formFieldStyle.warningIcon}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>Bike condition</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Select
                                    db_key_select="condition"
                                    defaultValue={condition}
                                    allowClear
                                    style={formFieldStyle.fieldStyle}
                                    placeholder="Select condition"
                                    onChange={value => this.handleChange(value, 'condition')}
                                >
                                    <Option key={1} value="5 - Showroom Condition">5 - Showroom Condition</Option>
                                    <Option key={2} value="4 - Good">4 - Good</Option>
                                    <Option key={3} value="3 - Average">3 - Average</Option>
                                    <Option key={4} value="2 - Below Average">2 - Below Average</Option>
                                    <Option key={5} value="1 - Very Poor">1 - Very Poor</Option>
                                </Select>
                                {condition !== '4 - Good' && condition !== '5 - Showroom Condition' &&
                                    <FlagIcon color="error" style={formFieldStyle.warningIcon}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        bike_details, loading, _id
    } = state.Leads.Lead_profile.Ref_bike_lead;
    const lead_id = state.Leads.Lead_profile.Lead_general.root_id;
    return {
        bike_details, _id, lead_id, loading
    };
};

export default connect(mapStateToProps, null)(BikeRagQuestions);


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BikeRagQuestions.js